import React from 'react'
import FundLiterature from './FundLiterature.jsx'
import './Literature.css'

function Literature(props) {
  return (
    <section
      className="section-content u-adel-reset"
      data-section-content="literature"
      id="literature"
    >
      <div className="u-sizeConstrained">
        <hr className="Rule Rule--thin Module-divider" role="presentation" />
        <FundLiterature {...props} />
      </div>
    </section>
  )
}

export default Literature
